import { useMemo, useState } from 'react'
import useFiltersStore from '../../../../../../../../../stores/filtersStore'
import useSeatmapStore from '../../../../../../../../../stores/seatmapStore'

import Button from 'react-bootstrap/Button'
import Collapse from 'react-bootstrap/Collapse'

import './legend.scss'

export default function Legend() {
  const [open, setOpen] = useState(false)
  const ticketGroups = useFiltersStore((state) => state.ticketGroups)
  const seatLookupTable = useSeatmapStore((state) => state.seatLookupTable)
  const seatmapData = useSeatmapStore((state) => state.data)

  const { hasAccessibleDA, hasAccessibleDB, hasAccessibleLegacy } =
    useMemo(() => {
      const groups = Array.isArray(ticketGroups) ? ticketGroups : []
      const seatGroups = Object.values(seatLookupTable || {})
      const seatmapSeats = Object.values(seatmapData?.seats || {})

      const normalizeType = (value) =>
        typeof value === 'string' ? value.toUpperCase() : ''

      const getTypeFromGroup = (group) =>
        normalizeType(
          group?.accessibleType ||
            group?.accessible_type ||
            group?.listing?.accessibleType ||
            group?.listing?.accessible_type ||
            group?.offer?.accessibleType ||
            group?.offer?.accessible_type
        )

      const allGroups = [...groups, ...seatGroups, ...seatmapSeats]
      const hasLegacyAccessible = allGroups.some(
        (group) =>
          (group?.accessible ||
            group?.listing?.accessible ||
            group?.offer?.accessible) &&
          getTypeFromGroup(group) === ''
      )

      return {
        hasAccessibleDA: allGroups.some(
          (group) => getTypeFromGroup(group) === 'DA'
        ),
        hasAccessibleDB: allGroups.some(
          (group) => getTypeFromGroup(group) === 'DB'
        ),
        hasAccessibleLegacy: hasLegacyAccessible,
      }
    }, [seatLookupTable, seatmapData, ticketGroups])

  return (
    <div className="vjx-legend" id="legend-container">
      <Button
        variant="link"
        className="btn-toggle"
        onClick={() => setOpen(!open)}
        aria-controls="legend"
        aria-expanded={open}
      >
        Legend
      </Button>
      <Collapse in={open}>
        <div id="legend">
          <ul id="legend-list">
            <li className="list-item unavailable">Unavailable</li>
            <li className="list-item available">Available</li>
            <li className="list-item resale">Exclusive</li>
            {Array.isArray(ticketGroups) &&
              ticketGroups.some((group) => group?.listing) && (
                <li className="list-item verified-resale">Verified resale</li>
              )}
            {hasAccessibleDA && (
              <li className="list-item accessible-da">
                Accessible - Open space
              </li>
            )}
            {hasAccessibleDB && (
              <li className="list-item accessible-db">
                Accessible - Chairback
              </li>
            )}
            {!hasAccessibleDA && !hasAccessibleDB && hasAccessibleLegacy && (
              <li className="list-item accessible">Accessibility</li>
            )}
          </ul>
        </div>
      </Collapse>
    </div>
  )
}
